<span
  #input
  tooltipPosition="top"
  tooltipZIndex="2100"
  [escape]="false"
  [hideDelay]="250"
  [iuValidationDisplay]="data?.hasValidation"
  [iuValidationDisplay.datacontainer]="this"
  [iuValidationDisplay.iconIdx]="1"
  [iuValidationDisplay.inputSelector]="'.calendar-input-container'"
  [iuValidationDisplay.valid]="isValid()"
  [life]="3000"
  pTooltip="{{ tooltip }}"
  [showDelay]="500"
  [style.backgroundColor]="backgroundColorCss"
  [style.display]="displayCss"
  (contextmenu)="onContextMenu($event)"
  (press)="onContextMenu($any($event))">
  <!-- [(ngModel)]="fieldValue" -->
  <!--     si on ajoute ceci, ça call un fieldvaluechange et donc rend la data not sync => showTime="true" hourFormat="24" -->
  <iu-prime-calendar
    #calendar
    [baseZIndex]="10000"
    [calendarConfig]="calendarConfig"
    [columnName]="data ? data.columnName : columnName"
    [disabled]="isReadOnly"
    [hasTodayBtn]="hasTodayBtn"
    [inputId]="uuid"
    [isGridEditor]="isGridEditor"
    [isLabelDisplay]="this.isLabelDisplay"
    [isStandalone]="this.isStandalone"
    [iupicsLocale]="locale"
    [label]="label"
    [monthNavigator]="true"
    [ngClass]="[hasConflict ? 'iu-field-conflict' : '']"
    [readonlyInput]="isReadOnly"
    [showButtonBar]="true"
    [showIcon]="true"
    [showTime]="this.data?.needTime"
    [yearNavigator]="true"
    yearRange="{{ this.rangeDate }}"
    (calendarConfigChange)="onCalendarConfigChange($event)"
    (checkGridEditorEmitter)="checkGridEditor()"
    (fieldChange)="fieldChange($event)"
    (onClose)="onClose()"
    (onShow)="onShow()" />
  @if (hasConflict && dataStored) {
    <i
      #spanInput
      aria-hidden="true"
      class="rtconflict fas fa-exclamation-triangle iconClass iu-field-conflict-icon"
      (click)="showConflictPanel($event)">
    </i>
  }
  @if (showValuePrefPanel) {
    <iu-prime-overlay #opValuePref appendTo="body" [dismissable]="false">
      <iu-value-preference-panel
        [data]="this.data"
        [dataStored]="this.dataStored"
        [fieldValue]="fieldValue"
        [overlayPanel]="opValuePref"
        [sourceComponent]="this"
        (closeEmitter)="toggleValuePreferencePanel($event)" />
    </iu-prime-overlay>
  }
</span>

<iu-prime-overlay #opConflict>
  <a class="data-conflict" (click)="chooseData($event, (dataStored?.data)[data.columnName], true); opConflict.hide()">{{
    (dataStored?.data)[data.columnName]
  }}</a>
  |
  <a class="data-conflict" (click)="chooseData($event, conflictedData, false); opConflict.hide()">{{
    conflictedData
  }}</a>
</iu-prime-overlay>
